import styled from 'styled-components';

import { colorsPalettes } from '@similarweb/styles';

export const StyledAdNetworksName = styled.span`
  width: 100%;
  display: flex;
  gap: 8px;
`;

export const StyledAdNetworksVisits = styled.span`
  flex: none;
  text-align: right;
  width: 80px;
`;

export const StyledAdNetworksChange = styled(StyledAdNetworksVisits)`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const StyledAdNetworksChangeValue = styled.span<{ isPositive: boolean }>`
  color: ${({ isPositive }) => (isPositive ? colorsPalettes.green.s100 : colorsPalettes.red.s100)};
`;

export const StyledAdNetworksChangeUnavailable = styled.span`
  color: ${colorsPalettes.carbon[250]};
`;
